// Widget-facing DTOs. The dashboard mints a session via the server with its
// API key; the widget itself never sees the API key — it only holds the
// opaque session token and sends it as X-Cortex-Session on chat requests.
//
// Minting flow: page boot → POST /v1/widget/session { agentId } with
// `Origin` header set by the browser. Server checks that origin against
// agents.allowed_origins. On success the widget gets a short-lived token +
// its absolute expiry time.
import { Type } from '@sinclair/typebox';
// Per-session message cap. Master plan §6: 50 messages / 100K tokens per
// 15-min session. Token cap is enforced by chat-limits (a separate gate);
// the session row only tracks message_count.
export const WIDGET_SESSION_MESSAGE_CAP = 50;
// Default TTL on issuance. Aligned with the master plan's 15-minute window.
export const WIDGET_SESSION_TTL_SECONDS = 15 * 60;
export const MintWidgetSessionSchema = Type.Object({
    agentId: Type.String({ format: 'uuid' }),
}, { $id: 'MintWidgetSessionInput', additionalProperties: false });
export const MintWidgetSessionResponseSchema = Type.Object({
    // Opaque token. Format is an implementation detail — clients treat it as
    // a blob and send it back via `X-Cortex-Session`.
    sessionToken: Type.String({ minLength: 16, maxLength: 256 }),
    expiresAt: Type.String({ format: 'date-time' }),
    messageCap: Type.Integer({ minimum: 1 }),
}, { $id: 'MintWidgetSessionResponse', additionalProperties: false });
//# sourceMappingURL=widget.js.map